<template>
  <div class="login">
    <div class="login-box">
      <v-tooltip v-model="show" bottom>
        <template v-slot:activator="{ on }">
          <img :src="brand.logo" alt="Logo Gestão Afiliados" class="logo mb-5" />
        </template>
        <span> v.{{ appVersion }}</span>
      </v-tooltip>

      <v-card class="card-login">
        <div class="d-flex justify-center">
          <img src="@/assets/img/find_replace.svg" alt="lupa" class="logo mb-5" />
        </div>

        <span class="d-flex justify-center mb-4"> Revisão de Conta </span>

        <p class="d-flex justify-center mb-3">
          Ei, que bom que você se registrou!<br/>
          Agora é só aguardar um pouco enquanto a gente dá aquele confere na sua conta.<br/>
          Logo mais estará tudo pronto pra você!
        </p>
        <span class="d-flex justify-center mb-3">
          Nós notificaremos após sua Ativação!
        </span>

        <div class="d-flex justify-center">
          <v-btn style="width: 170px; font-size: 20px;" :color="variables.colorButton" @click.prevent="quit"> Sair </v-btn>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import variables from '@/assets/styles/helpers/_variables.scss'
import brand from '@/core/brand'

export default {
  name: 'pendingAccount',
  components: {},

  data: () => ({
    show: false,
    snackbar: {
      toggle: false,
      type: null,
      msg: null
    },
    loading: false,
    showPassword: false,
    valid: true,
    user: {
      name: '',
      password: '',
    }
  }),
  computed: {
    variables: () => variables,
    brand: () => brand,
    appVersion () {
      return process.env.VUE_APP_VERSION
    }
  },

  methods: {
    quit () {
      this.$router.push('/home')
    }
  }
}
</script>

<style lang="scss" scoped src="@/assets/styles/auth.scss"></style>
<style lang="scss" scoped>
p {
  color: #848489;
  text-align: center;
  font-size: 16px;
}
</style>